class PointerHover {
    constructor(links) {
        this.links = links
        this.focusClassName = 'focus'
        this.shadowClassName = 'faded'

        this.handleMouseOver = this.handleMouseOver.bind(this)
        this.handleMouseOut = this.handleMouseOut.bind(this)

        this.videoContainer = document.querySelector('.js-video')

        links.forEach(link => {
            link.addEventListener('mouseenter', this.handleMouseOver)
            link.addEventListener('mouseleave', this.handleMouseOut)
        })
    }

    static getElementFromLink(link) {
        const { hoverId } = link.dataset
        return document.querySelector(hoverId)
    }

    fadeRest(currentLink, hide) {
        this.links.forEach(link => {
            if (currentLink !== link) {
                const picture = PointerHover.getElementFromLink(link)
                const { parentNode } = picture
                if (hide) {
                    parentNode.classList.add(this.shadowClassName)
                } else {
                    parentNode.classList.remove(this.shadowClassName)
                }
            }
        })
    }

    handleMouseOver({ currentTarget }) {
        const element = PointerHover.getElementFromLink(currentTarget)
        element.classList.add(this.focusClassName)
        this.videoContainer.classList.add(this.shadowClassName)
        this.fadeRest(currentTarget, true)
    }

    handleMouseOut({ currentTarget }) {
        const element = PointerHover.getElementFromLink(currentTarget)
        element.classList.remove(this.focusClassName)
        this.videoContainer.classList.remove(this.shadowClassName)
        this.fadeRest(currentTarget, false)
    }
}

export default PointerHover
